import {Component, inject, OnInit, signal, WritableSignal} from '@angular/core';
import {DatePipe} from '@angular/common';
import {CompanyService} from '@services/company.service';
import {IDocumentRetrievalAlert} from '@models/workspace.interface';

@Component({
  selector: 'app-expert-notifications',
  imports: [DatePipe],
  templateUrl: './expert-notifications.html',
})
export class ExpertNotifications implements OnInit {
  private readonly companyService = inject(CompanyService);

  loading: WritableSignal<boolean> = signal(false);
  notifications: WritableSignal<IDocumentRetrievalAlert[]> = signal([]);

  ngOnInit(): void {
    this.loadNotifications();
  }

  loadNotifications(): void {
    this.loading.set(true);
    this.companyService.getAllDocumentRetrievalAlerts().subscribe({
      next: (value) => {
        this.notifications.set(value);
        this.loading.set(false);
      },
      error: () => this.loading.set(false),
    });
  }

  markAsRead(notification: IDocumentRetrievalAlert): void {
    if (notification.read) return;
    this.companyService.markNotificationRead(notification.id).subscribe({
      next: () => this.loadNotifications(),
    });
  }

  documentTypeLabel(type: string): string {
    const labels: Record<string, string> = {
      avis_cfe: 'Avis CFE',
      info_fiscale: 'Informations fiscales',
      attestation_regularite: 'Attestation de régularité',
      attestation_vigilance: 'Attestation URSSAF',
      kbis: 'Kbis',
      provigis: 'Provigis',
    };
    return labels[type] ?? type;
  }
}
